/**
 * API Configuration
 * Configuración central para todas las llamadas a la API
 */

export const API_CONFIG = {
    baseURL: process.env.REACT_APP_API_URL || 'https://sandbox.jcretenciones.com.ve/api',
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
};

// Endpoints
export const ENDPOINTS = {
    // Proveedores (Vendors)
    PROVEEDORES: '/vendor',
    PROVEEDOR_BY_RIF: (rif) => `/vendor/${rif}`,

    // Empleados
    EMPLEADOS: '/employee',
    EMPLEADO_BY_RIF: (rif) => `/employee/${rif}`,

    // Retenciones IVA
    IVA_HEADER: '/retencion/iva',
    IVA_HEADER_BY_ID: (id) => `/retencion/iva/${id}`,
    IVA_HEADER_UPDATE: (id) => `/retencion/iva/header/${id}`,
    IVA_SUMMARY: '/retencion/iva/summary',
    IVA_ITEMS: '/retencion/iva/item',
    IVA_ITEMS_UPDATE: '/retencion/iva/item/update',
    IVA_ITEM_DELETE: (id) => `/retencion/iva/item/${id}`,
    IVA_ITEMS_BY_ID: (id) => `/retencion/iva/items/${id}`,
    IVA_FULL: '/retencion/iva/full',
    IVA_PDF: (id) => `/retencion/iva/${id}/pdf`,

    // Retenciones ISLR
    RETENCION_ISLR_HEADER: '/retencion/islr',
    RETENCION_ISLR_HEADER_UPDATE_OLD: '/retencion/islr/header/update', // Deprecado - usar PUT
    RETENCION_ISLR_HEADER_BY_ID: (id) => `/retencion/islr/header/${id}`,
    RETENCION_ISLR_HEADER_UPDATE: (id) => `/retencion/islr/header/${id}`, // PUT endpoint
    RETENCION_ISLR_ITEM: '/retencion/islr/item',
    RETENCION_ISLR_ITEM_UPDATE: '/retencion/islr/item/update',
    RETENCION_ISLR_ITEMS_DELETE: (id) => `/retencion/islr/items/${id}`,
    RETENCION_ISLR_FULL: '/retencion/islr/full',
    RETENCION_ISLR_SUMMARY: '/retencion/islr/summary',
    RETENCION_ISLR_DETAIL: (id) => `/retencion/islr/${id}`,
    RETENCION_ISLR_CHECK_CONTROL: '/retencion/islr/check-control',
    RETENCION_ISLR_CHECK_INVOICE: '/retencion/islr/check-invoice',
    RETENCIONES_ISLR_EMPLEADOS: '/retenciones/islr-empleados',
    RETENCION_ISLR_PDF: (id) => `/retencion/islr/${id}/pdf`,
    RETENCION_ISLR_XML: '/retencion/islr/xml',

    // Retenciones Otros
    RETENCION_OTROS_HEADER: '/retencion/otros',
    RETENCION_OTROS_HEADER_UPDATE: '/retencion/otros/update',
    RETENCION_OTROS_HEADER_BY_ID: (id) => `/retencion/otros/${id}`,
    RETENCION_OTROS_DETAIL: (id) => `/retencion/otros/${id}`,
    RETENCION_OTROS_SUMMARY: '/retencion/otros/summary',
    RETENCION_OTROS_ITEM: '/retencion/otros/item',
    RETENCION_OTROS_ITEM_UPDATE: '/retencion/otros/item/update',
    RETENCION_OTROS_ITEMS_DELETE: (id) => `/retencion/otros/items/${id}`,
    RETENCION_OTROS_FULL: '/retencion/otros/full',
    RETENCION_OTROS_CHECK_CONTROL: '/retencion/otros/check-control',
    RETENCION_OTROS_CHECK_INVOICE: '/retencion/otros/check-invoice',

    // Retenciones ARCV
    RETENCION_ARCV: '/retencion/arcv',
    RETENCION_ARCV_BY_ID: (id) => `/retencion/arcv/${id}`,
    RETENCION_ARCV_PROCESS: '/retencion/arcv/process',
    RETENCION_ARCV_RETAINABLE: '/retencion/arcv/retainable',

    // Comprobantes
    COMPROBANTES: '/comprobantes',
    COMPROBANTE_BY_ID: (id) => `/comprobantes/${id}`,

    // Company
    COMPANY: {
        BASE: '/company',
        BY_RIF: (rif) => `/company/${rif}`,
        TAX_RATES: (rif) => `/company/${rif}/taxrates`,
        OTHER_PERCENTAGES: (rif) => `/company/${rif}/otherpercentages`,
        TAX_UNIT: (rif) => `/company/${rif}/taxunit`,
        SETTINGS: (rif) => `/company/${rif}/settings`,
        LOGO: (rif) => `/company/${rif}/logo`,
        SIGNATURE: (rif) => `/company/${rif}/signature`,
        SEAL: (rif) => `/company/${rif}/seal`,
        IMAGES: (rif) => `/company/${rif}/images`
    },

    // Tax Concepts
    TAX_CONCEPTS: '/taxconcepts',
    TAX_CONCEPT_BY_ID: (id) => `/taxconcepts/${id}`,

    // Document Types
    DOCUMENT_TYPES: '/documenttypes',
    DOCUMENT_TYPE_BY_ID: (id) => `/documenttypes/${id}`,

    // Autenticación (si es necesaria)
    AUTH_LOGIN: '/auth/login',
    AUTH_LOGOUT: '/auth/logout',
    AUTH_REFRESH: '/auth/refresh'
};

// Códigos de error comunes
export const ERROR_CODES = {
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    SERVER_ERROR: 500,
    NETWORK_ERROR: 'NETWORK_ERROR'
};
